import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

export const getSalesPersonsSchema = z.array(
  baseObjectSchema.extend({
    code: z.string(),
    name: z.string(),
    userID: z.string(),
    mwSalesPersonTypeID: z.string(),
    sequence: z.number(),
    rootCode: z.string(),
    onlineSearchLevel: z.union([z.literal(1), z.literal(2)]),
    salesPersonParentID: z.string().optional(),
    user: z.object({
      id: z.string(),
      userName: z.string(),
    }),
    companySite: z
      .object({
        id: z.string(),
        name: z.string(),
        companyID: z.string(),
      })
      .optional(),
    mwSalesPersonType: z.object({
      id: z.string(),
      name: z.string(),
      code: z.string(),
      isActive: z.boolean(),
      isFromManager: z.boolean(),
    }),
    mwSalesPersonsAccessMaxLevel: z.object({
      id: z.string(),
      name: z.string(),
      level: z.number(),
    }),
    companySiteID: z.string(),
    mwSalesPersonsAccessMaxLevelID: z.string(),
  })
);

export type GetSalesPersonsResponse = z.infer<typeof getSalesPersonsSchema>;
